<template>
  <div id="box">
    <iframe
      v-show="isShowCPS"
      class="my_iframe"
      id="fram"
      width="100%"
      height="100%"
      :src="iframeUrl"
      frameborder="0"
    ></iframe>
    <div v-show="isShowCenter" class="studenttask_warp">
      <el-drawer
        title="我是标题"
        class="drawer1"
        :modal-append-to-body="false"
        :visible.sync="drawer1"
        :with-header="false"
      >
        <div class="drawer1_r_box" v-if="drawerState==4">
          <header>
            <span>消息</span>
            <img @click="drawer1 = false" src="../../../../../../static/images/close.png" />
          </header>

          <div class="drawer1_r_title">
            <p>发送人:</p>
            {{msgObj.toUserName}} ({{msgObj.fromStationName}})
          </div>
          <div v-if="msgObj.type==0" class="drawer1_r_title">
            <p>内容:</p>任务回退
          </div>
          <div v-else class="drawer1_r_title">
            <p>内容:</p>无
          </div>
          <div class="drawer1_r_title">
            <p>留言:</p>
            {{msgObj.remark}}
          </div>
        </div>
      </el-drawer>
      <!-- 2是大的  1是小的  2：处理 进度 1:消息 退回 -->
      <el-drawer
        :modal-append-to-body="false"
        title="我是标题"
        class="drawer2"
        :visible.sync="drawer2"
        :with-header="false"
      >
        <div class="r_box" v-if="drawerState==2">
          <header>
            <span>进度查看</span>
            <img @click="drawer2 = false" src="../../../../../../static/images/close.png" />
          </header>
          <div class="steps_box">
            <el-steps :active="list2Num" finish-status="success" align-center>
              <el-step v-for="v in list2" :title="v.stationName" :key="v.id" :description="v.name"></el-step>
            </el-steps>
          </div>
          <div class="r_ul_box">
            <ul class="task_r_ul">
              <li class="r_li_header">
                <div class="r_li_div_No">序号</div>
                <div class="r_li_div_record">操作记录</div>
                <div class="r_li_div_time">提交时间</div>
                <div class="r_li_div_message">留言</div>
              </li>
              <li v-for="(item,index) in list3 " :key="index">
                <div class="r_li_div_No">{{index+1}}</div>
                <div
                  class="r_li_div_record"
                  v-if="item.toStationName!=null"
                >{{item.fromUserName}}({{item.fromStationName}})给{{item.toUserName}}({{item.toStationName}})推送了任务流</div>
                <div
                  class="r_li_div_record"
                  v-if="item.toStationName==null"
                >{{item.fromUserName}}({{item.fromStationName}})完结任务</div>
                <div class="r_li_div_time" v-if="item.createTime">{{item.createTime.slice(0,10)}}</div>
                <div class="r_li_div_time" v-if="!item.createTime"></div>
                <!-- <div class="r_li_div_time" >我是时间 现在获取不到</div> -->
                <div class="r_li_div_message" :title="item.remark">{{item.remark}}</div>
              </li>
            </ul>
          </div>
        </div>
        <div class="r_box2" v-if="drawerState==1">
          <!-- <div class="r_header">{{obj.taskName}}</div> -->
          <header>
            <span>{{obj.taskName}}</span>
            <img @click="drawer2 = false" src="../../../../../../static/images/close.png" />
          </header>
          <div class="r_ct editorShowArea ql-editor" @click="imgCilck($event)" v-html="obj.questionContent"></div>
          <div class="r_footer">
            <button @click="jumpCPS(obj,obj.id,'ctx')">财天下</button>
            <button @click="jumpCPS(obj,obj.id,'ptx')">票天下</button>
            <button @click="jumpCPS(obj,obj.id,'jss')">金税师</button>
          </div>
        </div>
        <div class="r_box2" v-if="drawerState==3">
          <header>
            <span>{{obj.taskName}}</span>
            <img @click="drawer2 = false" src="../../../../../../static/images/close.png" />
          </header>
          <div class="r_ct editorShowArea ql-editor" @click="imgCilck($event)" v-html="obj.questionContent"></div>
        </div>
      </el-drawer>
      <div class="student_task_t">
        <div class="task_t_l">
          <button class="btn_null">我的岗位</button>
          <ul class="post_ul">
            <li v-for="(item,index) in postList" :key="index">{{item.name}}</li>
          </ul>
          <!-- <div class="post_date_box">
            <label for="post_date">换岗记录 :</label>
            <el-select id="post_date" v-model="postDateValue" placeholder="请选择">
              <el-option
                v-for="item in postDateList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>-->
        </div>
        <div class="task_t_r">
          <input
            class="task_t_r_search"
            type="text"
            v-model="realTaskData.taskName"
            placeholder="请输入任务名称"
            @keyup.13="search"
          />
          <el-button @click="search" class="task_t_r_btn">查询</el-button>
        </div>
      </div>
      <div class="student_task_b">
        <div class="student_task_date">
          <i>日期 :</i>
          <div>
            <el-radio-group @change="dateChange" v-model="dateValue">
              <el-radio-button label="全部"></el-radio-button>
              <el-radio-button label="今天"></el-radio-button>
              <el-radio-button label="本周"></el-radio-button>
              <el-radio-button label="本月"></el-radio-button>
              <el-radio-button label="上月"></el-radio-button>
            </el-radio-group>
          </div>
          <div>
            <button class="student_task_b_btn_null" @click="clickDateButton" v-if="dateButton">自定义</button>
            <div v-else class="picker">
              <el-date-picker
                class="el_calendar1"
                v-model="value1"
                :clearable="false"
                @change="getDate1()"
                type="date"
                placeholder="开始日期"
              ></el-date-picker>
              <span class="heng"></span>
              <el-date-picker
                class="el_calendar2"
                v-model="value2"
                :clearable="false"
                @change="getDate1()"
                type="date"
                placeholder="结束日期"
              ></el-date-picker>
            </div>
          </div>
        </div>
        <div class="student_task_company" :class="!companyListState?'group_true':''">
          <i>公司 :</i>
          <div v-if="!checkboxState" class="largeArray">
            <el-radio-group v-model=" companyValue" @change="search">
              <el-radio-button label="全部"></el-radio-button>
              <el-radio-button
                v-for="item in companyList"
                :label="item.id"
                :key="item.id"
              >{{item.name}}</el-radio-button>
            </el-radio-group>
          </div>
          <div v-if="checkboxState" class="largeArray">
            <el-checkbox-group v-model="checkboxGroup2" @change="search" size="medium">
              <el-checkbox-button disabled label="全部"></el-checkbox-button>
              <el-checkbox-button
                v-for="item in companyList"
                :label="item.id"
                :key="item.id"
              >{{item.name}}</el-checkbox-button>
            </el-checkbox-group>
          </div>
          <div class="student_task_company_r">
            <button
              v-if="!checkboxState"
              @click="clickCheck(1)"
              class="btn_white"
            >多选</button>
            <button
              v-else
              @click="clickCheck(0)"
              class="btn_white"
            >单选</button>

            <button class="btn_white" style="width:61px;" @click="companyListChange">
              更多
              <i v-if="companyList.length>6" class="el-icon-arrow-up"></i>
              <i v-if="companyList.length<=6" class="el-icon-arrow-down"></i>
            </button>
          </div>
        </div>
        <div class="student_task_type">
          <i>类型 :</i>
          <div>
            <el-radio-group v-model="typeValue" @change="search">
              <el-radio-button label="全部"></el-radio-button>
              <el-radio-button
                v-for="item in taskFlowList"
                :label="item.id"
                :key="item.id"
              >{{item.name}}</el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <div class="student_task_state">
          <i>状态 :</i>
          <el-radio-group v-model="stateValue" @change="search">
            <el-radio-button label="全部">全部</el-radio-button>
            <el-radio-button :label="0">待办</el-radio-button>
            <el-radio-button :label="4">等待</el-radio-button>
            <el-radio-button :label="1">处理中</el-radio-button>
            <el-radio-button :label="2">已处理</el-radio-button>
            <el-radio-button :label="3">已完成</el-radio-button>
          </el-radio-group>
        </div>
				<p class="task_title">提示：您有{{reslTaskNum}}笔新业务</p>
        <ul class="task_ul_header">
          <li class="li_header">
            <div class="li_div_No">序号</div>
            <div class="li_div_taskName">任务名称</div>
            <div class="li_div_taskCompany">所属公司</div>
            <div class="li_div_time">岗位</div>
            <div class="li_div_time">任务发布时间</div>
            <div class="li_div_state">状态</div>
            <div class="li_div_schedule">任务进度</div>
            <div class="li_div_message">留言</div>
            <div class="li_div_operation">操作</div>
          </li>
        </ul>
        <ul class="task_ul" v-if="list.length>0">
          <li v-for="(item,index) in list " :key="index">
            <div class="li_div_No"><i v-if="!item.doTaskTime" style="color: red;">new</i><span>{{(pageTotal.currentPage-1)*pageTotal.pageSize+index+1}}</span></div>
            <div class="li_div_taskName">{{item.taskName}}</div>
            <div class="li_div_taskCompany">{{item.companyName}}</div>
            <div class="li_div_time">{{post(item.stationId)}}</div>
            <div class="li_div_time" v-if="item.pushTaskTime">{{item.pushTaskTime.slice(0,10)}}</div>
            <div class="li_div_time" v-if="!item.pushTaskTime"></div>
            <div class="li_div_state" v-if="item.teamStatus==1&&item.userStatus==0">等待</div>
            <div
              class="li_div_state"
              v-if="item.teamStatus==1&&item.userStatus==1&&item.doTaskTime==null"
            >待办</div>
            <div
              class="li_div_state"
              v-if="item.teamStatus==1&&item.userStatus==1&&item.doTaskTime!=null"
            >处理中</div>
            <div
              class="li_div_state"
              v-if="item.teamStatus==1&&item.userStatus==2&&item.doTaskTime!=null&&item.submitTime!=null"
            >已处理</div>
            <div class="li_div_state" v-if="item.teamStatus==2&&item.userStatus==2">已完成</div>
            <div class="li_div_schedule">{{item.finishTaskNum}}/{{item.allTaskNum}}</div>
            <div class="li_div_message" v-if="item.msgId" @click="ckdrawer1(4,item)">新消息</div>
            <div class="li_div_message" v-if="!item.msgId">{{item.msgId}}</div>
            <div class="li_div_operation">
              <button class="btn_white" v-if="(item.teamStatus==1&&item.userStatus==1&&item.doTaskTime==null) || (item.teamStatus==1&&item.userStatus==1&&item.doTaskTime!=null) || (item.teamStatus==2&&item.userStatus==2&&item.lastStation)" @click="ckdrawer2(1,item)">处理</button>
              <button class="btn_white" v-if="(item.teamStatus==1&&item.userStatus==2&&item.doTaskTime!=null&&item.submitTime!=null) || (item.teamStatus==1&&item.userStatus==0) || (item.teamStatus==2&&item.userStatus==2&&!item.lastStation)" @click="ckdrawer2(3,item)">浏览</button>
              <button class="btn_white" @click="ckdrawer2(2,item)">进度</button>
            </div>
          </li>
        </ul>
      </div>
      <div v-if="!paginationStatus" class="null_box">
        <img src="../../../../../../static/images/wujieguo.png" />
        <p>暂无数据</p>
      </div>
      <el-pagination
        v-if="pageTotal.total>10"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="pageTotal.currentPage"
        background
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageTotal.pageSize"
        :pager-count="5"
        layout="sizes, prev, pager, next"
        :total="pageTotal.total"
        class="paginator"
      ></el-pagination>
    </div>
    <el-dialog
      v-dialogDrag
      :close-on-click-modal="false"
      :modal="false"
      :visible.sync="dialogVisible"
      width="50%"
      v-if="dialogVisible && !isSmall"
      :show-close="false"
      customClass="customHeight"
    >
      <span class="dia_span">
        <span style="float:left;margin-top: 5px;">字号：</span>
        <el-radio-group style="float:left;" @change="fontChange" v-model="fontSize">
          <el-radio-button label="默认"></el-radio-button>
          <el-radio-button label="小号"></el-radio-button>
        </el-radio-group>
        <span style="float:left;margin-left:25px;margin-top: 5px;">布局：</span>
        <el-radio-group style="float:left;" v-model="diaLayout" @change="layoutChange">
          <el-radio-button label="浮窗"></el-radio-button>
          <el-radio-button label="左右"></el-radio-button>
          <el-radio-button label="上下"></el-radio-button>
        </el-radio-group>
        <i v-if="isMini" @click="small" class="small_icon el-icon-minus"></i>
        <i v-if="isHalf" @click="largeHalf" class="large_icon el-icon-copy-document"></i>
        <i v-else @click="large" class="large_icon el-icon-full-screen"></i>
        <i
          v-bury="{route: $route,template:template}"
          style="margin-right: 15px;"
          @click="back"
          class="el-icon-back"
        ></i>
      </span>
      <el-tabs style="padding: 0 20px" v-model="activeName">
        <el-tab-pane label=" 题 面 " name="first">
          <div :class="{'font_size':changeFont}" class="aside">
            <div class="qesCont editorShowArea ql-editor" @click="imgCilck($event)" v-html="obj.questionContent"></div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <el-button class="task_submit" @click="taskSubmit">任务提交</el-button>
      <el-button class="task_submit2" v-if="backState" @click="taskfallback">退回</el-button>
      <el-dialog
        width="30%"
        title="提示"
        :show-close="false"
        :visible.sync="innerVisible"
        :close-on-click-modal="false"
        append-to-body
        class="count_down_dialog"
      >
        <div class="count_down_main">
          <p>您的操作已经提交</p>
          <p>
            <span>{{countDown}}秒</span>后将自动返回待办任务列表页
          </p>
        </div>
      </el-dialog>
      <!-- 退回 -->
      <el-dialog
        width="30%"
        title="退回"
        :show-close="false"
        :visible.sync="innerVisible2"
        :close-on-click-modal="false"
        append-to-body
        class="count_down_dialog2"
      >
        <div class="count_down_main">
          <div class="count_down_dialog_r_title">
            <p>任务退回给:</p>
            {{this.backObj.name}} ({{this.backObj.stationName}})
          </div>
          <div class="count_down_dialog_r_ct">
            <p>留言:</p>
            <textarea placeholder="请输入退回理由" v-model="notedata" maxlength="200" cols="25" rows="5"></textarea>
            <p>{{notedata.length}}(上限200)</p>
          </div>
          <div class="count_down_dialog_r_footer">
            <el-button type="primary" @click="fallback(0)" class="cancel">取消</el-button>
            <el-button type="primary" @click="fallback(1)">确定</el-button>
          </div>
        </div>
      </el-dialog>
    </el-dialog>
    <drag-icon v-if="isSmall"></drag-icon>
		<!-- 查看图片放大 -->
		<div class="bigImg" v-if="showBigImg">
			<div class="mask"></div>
			<div class="imgBox"><img @click="clickMask" :src="imgUrl" alt=""></div>
		</div>
  </div>
</template>
<script>
import * as api from "../../../../../api/realTaskApi";
import Pagination from "../../../../paginator/paginator";
import dragIcon from "../courseware/dragIcon";
import { Base64 } from "js-base64";
import crypto from "crypto";
import axios from "axios";
import qs from "qs";
export default {
  components: {
    Pagination,
    dragIcon,
  },
  data() {
    return {
      classId: JSON.parse(this.$route.query.classId),
      courseId: JSON.parse(this.$route.query.id),
      userId: JSON.parse(sessionStorage.getItem("userId")),
      subjectId: 0,
      paramsList: [], // 跳转里的 判断岗位id与选中id是否相等 想得就往数组里添加 提交
      list: [], //基本列表
      listState: false,
      list2: [], //进度条
      list3: [], //进度条下面的list
      list2Num: 0, //进度条的长度
      postList: [], //岗位列表
      dateButton: 1, //用来切换是否手动选择时间的状态
      value1: "", //用来控制时间的值
      value2: "", //用来控制时间的值
      clearable: false,
      dateValue: "全部", //  时间
      companyValue: "全部", //  公司
      typeValue: "全部", //  类型
      stateValue: "全部", //  状态
      checkboxState: false, //用来切换是单选还是复选
      checkboxGroup2: [], //复选框数组
      companyList: [], //空数组 默认小数组 点击变成大数组 来回切换
      companyList1: [], //更多的小数组 下面是大数组
      companyList2: [], //点击更多后 需要用这个数据
      companyListState: false, //公司的状态 用来判断公司的同台class
      taskFlowList: [], //类型的数组
      drawer1: false, // 弹出框的状态
      drawer2: false, // 弹出框的状态
      drawerState: 0, //用来控制弹出框 判断是哪个
      userStatusFlag: false, //控制是否是当前岗位
      notedata: "",
      pageTotal: {
        //分页
        currentPage: 1,
        pageSize: 10,
        total: 1,
      },
      paginationStatus: false,
      postDateList: [
        //岗位时间
        { value: 0, label: "2020/6/22---19:18" },
        { value: 1, label: "2020/6/23---19:18" },
        { value: 2, label: "2020/6/24---19:18" },
        { value: 3, label: "2020/6/25---19:18" },
        { value: 4, label: "2020/6/26---19:18" },
      ],
      postDateValue: "", //换岗时间的值
      realTaskData: {
        //当前搜索对象
        classId: JSON.parse(this.$route.query.classId),
        companyIds: [],
        courseId: JSON.parse(this.$route.query.id),
        doTaskEndTime: "",
        doTaskStartTime: "",
        endDate: "",
        pageNo: 1,
        pageSize: 10,
        questionIds: [],
        startDate: "",
        stationIds: [],
        status: null,
        taskFlowType: "",
        taskName: "",
        teamId: 0,
        type: 0,
        userId: JSON.parse(sessionStorage.getItem("userId")),
      },
      obj: {}, //当前选中的对象
      //=============================
      userType: localStorage.getItem("userType"), //用户身份
      courseType: "", // 课程类型，判断用户是不是有权限跳转
      type: "", // 课程类型
      classNames: null,
      myId: "",
      isShowCPS: false, //三天下窗口
      isShowCenter: true, //任务主体
      iframeUrl: "", //跳转地址
      dialogVisible: false, //内部浮窗
      fontSize: "默认", //字体大小
      diaLayout: "浮窗", //浮窗结构
      changeFont: false, //变换字体
      isHalf: false,
      isMini: true,
      isSmall: false, //缩小的圆
      activeName: "first", // tag切换标记
      template: {}, //埋点对象
      innerVisible: false, //提交倒计时
      innerVisible2: false, //退回状态
      backState: false, //退出按钮的状态
      countDown: 3, //提交倒计时
      timer: null, //提交倒计时
      backObj: {
        code: "",
        name: "",
        stationId: 0,
        stationName: "",
        userId: 0,
      },
      msgObj: {},
			showBigImg: false,
			imgUrl: '',
			reslTaskNum: 0
    };
  },
  created() {
    //获取各种初始信息
    let url = `/${this.classId}`;
    api.getSubjectId(url).then((rs) => {
      this.subjectId = rs.data.subjectId;
      this.getPost();
    });
  },
  watch: {
    isShowCPS(newVal) {
      if (newVal) {
        $(".switch_wrap main").css("height", "100%");
      } else {
        $(".switch_wrap main").css("height", "calc(100% - 56px)");
      }
    },
  },

  methods: {
    post: function (val) {
      let str = "";
      this.postList.forEach((v) => {
        if (v.id == val) {
          str = v.name;
        }
      });
      return str;
    },
		getRealTaskNum(){
			let param = {
				classId: this.$route.query.classId,
				courseId: this.$route.query.id,
				teamId: this.realTaskData.teamId
			}
			api.getRealTaskNum(param).then(res=>{
				console.log(res)
				if(res.code == 0){
					this.reslTaskNum = res.data?res.data:0
				}
			})
		},
    //获取list
    getList() {
      api.getRealTaskList(this.realTaskData).then((rs) => {
        if (rs.data.list != null) {
          this.list = rs.data.list;
          this.pageTotal.total = rs.data.total;
          this.paginationStatus = true;
        } else {
          this.list = [];
          this.paginationStatus = false;
          this.pageTotal.total = rs.data.total;
        }
        return;
      });
    },
    getPost() {
      //获取公司数组
      let url2 = `/${this.subjectId}`;
			let cid = this.$route.query.id;
      api.getCompanyList(cid).then((rs) => {
        //判断data的长度 因为有一个更多效果 如果超过6个就 先放在小数组里 点击更多 切换到大数组
        let list = []
        if(rs.data.length>0){
          rs.data.forEach(v=>{
            let arr = []
            rs.data.forEach(v=>{
              // if(v.lableIds.includes(4)){
                arr.push(v)
              // }
            })
            list = arr
          })
        }else{
          list = []
        }

        if (list.length > 6) {
          this.companyList = list.slice(0, 6);
          this.companyList1 = list.slice(0, 6);
          this.companyList2 = list;
        } else {
          this.companyList = list;
          this.companyList1 = list;
          this.companyList2 = list;
        }
        if (list.length == 0) {
          this.companyList = [
            {
              id: 0,
              name: "暂无数据",
              templateCode: "001",
              createTime: null,
              createUser: null,
            },
          ];
          this.companyList1 = [
            {
              id: 0,
              name: "暂无数据",
              templateCode: "001",
              createTime: null,
              createUser: null,
            },
          ];
          this.companyList2 = [
            {
              id: 0,
              name: "暂无数据",
              templateCode: "001",
              createTime: null,
              createUser: null,
            },
          ];
        }
      });
      //获取状态数组
      api.getStateList(url2).then((rs) => {
        if (rs.data.length > 0) {
          this.taskFlowList = rs.data;
        } else {
          this.taskFlowList = [{ id: 0, name: "暂无数据" }];
        }
      });
      //获取岗位
      let url = `/${this.courseId}/${this.classId}`;
      api.getPost(url).then((rs) => {
        if (rs.data.length > 0) {
          this.realTaskData.teamId = rs.data[0].teamId;
          this.postList = rs.data;
          this.getList();
					this.getRealTaskNum();
        } else {
          return;
        }
      });
    },
    clickCheck(state){
      if(state){
          this.checkboxState = !this.checkboxState;
          this.checkboxGroup2=[];
          this.companyValue='null'
      }else{
        this.checkboxState = !this.checkboxState;
        this.checkboxGroup2=[];
        this.companyValue='全部';
        this.search()
      }
      // this.search()
    },
    search() {
      if (this.value1 && !this.value2) {
        this.$message({
          message: "请选择日期结束时间",
          type: "warning",
        });
        return;
      } else if (!this.value1 && this.value2) {
        this.$message({
          message: "请选择日期开始时间",
          type: "warning",
        });
        return;
      }
       if (this.companyValue == "全部") {
            //如果公司是全部 就 是传空
            this.realTaskData.companyIds = [];
          } else if (this.companyValue == "null") {
            //如果是null 就是变成了多选状态 等于多选的数组
            this.realTaskData.companyIds = this.checkboxGroup2;
          } else {
            //如果都不是 那就是自己本身
            this.realTaskData.companyIds = [this.companyValue];
          }
          console.log(this.checkboxGroup2)
      if (this.typeValue == "全部") {
        this.realTaskData.taskFlowType = "";
      } else {
        this.realTaskData.taskFlowType = this.typeValue;
      }
      if (this.stateValue == "全部") {
        this.realTaskData.status = "";
      } else {
        this.realTaskData.status = this.stateValue;
      }

      if(this.checkboxState&&this.checkboxGroup2.length==0){
             this.list = []
             this.pageTotal.total = 1
             this.paginationStatus = false
      }else{
        console.log(this.checkboxState)
        console.log(this.checkboxGroup2)
         this.getList();
      }
    },
    ckdrawer1(i, v) {
      this.drawer1 = true;
      this.drawerState = i;
      let url = `/${v.msgId}`;
      //因为现在都是空 暂时不知道里面的值是什么样的
      api.getTeskmsg(url).then((rs) => {
        this.msgObj = rs.data;
      });
    },
    ckdrawer2(i, v) {
      //大弹出框 判断12 是进度 还是处理
      this.notedata = "";
      if (v.sort > 0 && (v.userStatus == 1 || v.userStatus == 2 || v.lastStation)) {
        this.backState = true;
      } else {
        this.backState = false;
      }
      this.drawerState = i;

      this.obj = v;
      let url = `/${v.teamTaskId}`;
      this.paramsList = [];
      if (i == 1) {
        let data = {
          id: this.obj.id,
          sort: this.obj.sort,
          stationId: this.obj.stationId,
          status: 0, //userStatus
          teamTaskId: this.obj.teamTaskId,
        };
        this.userStatusFlag = true;
        this.drawer2 = true;
				$(".r_ct").find('p img').removeClass('big')
				if(!(v.userStatus == 2 && v.lastStation)){
					api.realTeskhandler(data).then((rs) => {
						this.getRealTaskNum();
						this.getList();
					});
				}
        this.postList.forEach((v) => {
          if (v.id == this.obj.stationId) {
            this.paramsList.push(v.code);
          }
        });
      } else if (i == 2) {
        //获取进度接口
        if (i == 2) {
          this.drawer2 = true;
					$(".r_ct").find('p img').removeClass('big')
        }
        api.getTeskProgress(url).then((rs) => {
          if (rs.code == 0) {
            this.list2 = rs.data;
            // this.list2Num = rs.data.
            var num = 0;
            num = rs.data.findIndex((v) => {
              return v.status == 1;
            });
            if (num == -1) {
              num = rs.data.length + 1;
            }
            this.list2Num = num;
          } else {
            this.$message.error(rs.msg);
          }
        });
        let data = {
          rotationBeginTime: "",
          rotationEndTime: "",
          teamTaskId: v.teamTaskId,
        };
        //获取进度接口
        this.list3 = [];
        api.getTeskRecord(data).then((rs) => {
          if (rs.code == 0) {
            if (rs.data.length > 0) {
              this.list3 = rs.data;
            }
          } else {
            this.$message.error(rs.msg);
          }
        });
      } else if (i == 3) {
        this.drawerState = i;
        this.userStatusFlag = true;
        this.drawer2 = true;
        this.obj = v;
				$(".r_ct").find('p img').removeClass('big')
      }
    },
    clickDateButton(e) {
      //切换日期的时间
      this.dateButton = 0;
      this.dateValue = "";
    },
    getDate1() {
      //因为没有使用那种一体的 所以自己写了个时间判断
      if (this.value1 > this.value2 && this.value1 && this.value2) {
        let a = this.value1;
        let b = this.value2;
        let c = a;
        this.value1 = b;
        this.value2 = c;
      }
      if (this.value1 && this.value2) {
        this.realTaskData.startDate = this.value1;
        this.realTaskData.endDate = this.value2;
        this.getList();
      }
    },
    dateChange(e) {
      // 单选 全部 今天 本周 本月 上月 改变触发事件
      let _this = this;
      //当点击单选的时候 清空 日期
      if (this.dateValue != "") {
        this.dateButton = 1;
        this.value1 = "";
        this.value2 = "";
      }
      if (this.dateValue == "全部") {
        _this.realTaskData.startDate = "";
        _this.realTaskData.endDate = "";
      }
      if (this.dateValue == "今天") {
        var start = new Date();
        start.setHours(0);
        start.setMinutes(0);
        start.setSeconds(0);
        // 获取当月的最后一天
        var end = new Date();
        end.setHours(23);
        end.setMinutes(59);
        end.setSeconds(59);
        _this.realTaskData.startDate = start;
        _this.realTaskData.endDate = end;
      }
      if (this.dateValue == "本周") {
        //按周日为一周的最后一天计算
        var start = new Date();
        var day = start.getDay();
        //获取天 然后 找到星期一  确定开始时间 +6 等于结束时间
        var num = 0;
        for (var i = 1; i < day; i++) {
          num = i;
        }
        start.setDate(start.getDate() - num);
        start.setHours(0);
        start.setMinutes(0);
        start.setSeconds(0);
        // // 获取当月的最后一天
        var end = new Date();
        end.setDate(start.getDate() + 6);
        end.setHours(23);
        end.setMinutes(59);
        end.setSeconds(59);
        _this.realTaskData.startDate = start;
        _this.realTaskData.endDate = end;
      }
      if (this.dateValue == "本月") {
        // 获取当前月的第一天
        var start = new Date();
        start.setDate(1);
        start.setHours(0);
        start.setMinutes(0);
        start.setSeconds(0);
        // 获取当月的最后一天
        var end = new Date();
        //获取最后一天 设置 年 月 日 日是0就会获取前月的最后一天 可是 这里获取的是下月一日 不知为何
        end.setDate(
          new Date(end.getFullYear(), end.getMonth() + 1, 0).getDate()
        );

        end.setHours(23);
        end.setMinutes(59);
        end.setSeconds(59);
        _this.realTaskData.startDate = start;
        _this.realTaskData.endDate = end;
      }
      if (this.dateValue == "上月") {
        // 获取当上月的第一天
        var start = new Date();
        start.setDate(1);
        start.setMonth(start.getMonth() - 1);
        start.setHours(0);
        start.setMinutes(0);
        start.setSeconds(0);
        // 获取当前月的最后一天
        var end = new Date();
        end.setMonth(end.getMonth() - 1);
        end.setDate(
          new Date(end.getFullYear(), end.getMonth() + 1, 0).getDate()
        );

        end.setHours(23);
        end.setMinutes(59);
        end.setSeconds(59);

        _this.realTaskData.startDate = start;
        _this.realTaskData.endDate = end;
      }
      // if(dateButton){

      // }
      this.search();
    },
    companyListChange() {
      // 判断当前是哪个数组 然后切换
      if (this.companyList2.length <= 6) {
        this.$tipsDialog(
          "提示",
          "没有更多了",
          "",
          "el-icon-warning",
          "rgb(255, 178, 60)"
        )
          .then(() => {
            return;
          })
          .catch(() => {
            return;
          });
        return;
      }
      if (this.companyList.length == this.companyList1.length) {
        this.companyList = this.companyList2;
      } else {
        this.companyList = this.companyList1;
      }
      this.companyListState = !this.companyListState;
    },
    handleCurrentChange(val) {
      this.pageTotal.currentPage = val;
      let data = this.realTaskData;
      data.pageNo = this.pageTotal.currentPage;
      data.pageSize = this.pageTotal.pageSize;
      api.getRealTaskList(this.realTaskData).then((rs) => {
        this.list = rs.data.list;
      });
    },
    handleSizeChange(val) {
      this.pageTotal.pageSize = val;
      this.realTaskData.pageSize = val;
      this.realTaskData.pageNo = 1;
      this.pageTotal.currentPage = 1;
      api.getRealTaskList(this.realTaskData).then((rs) => {
        this.list = rs.data.list;
      });
    },
    setSha1(url) {
      //sha1加密
      const hmac = crypto.createHmac("sha1", "123456");
      hmac.update(url);
      return hmac.digest("hex");
    },
    jumpCPS(data, id, flag) {
      let that = this;
      // 时间戳
      let time = new Date().getTime() + "";
      // 一个普通的对象遍历用
      var rolesStr = "";
      this.paramsList.forEach((v, i) => {
        if (this.paramsList.length == i + 1) {
          rolesStr += v;
        } else {
          rolesStr += v + ",";
        }
      });

      let mobile = sessionStorage.getItem("mobile");
      let dataObj = {
        classId: this.classId,
        courseId: this.courseId,
        mobile: mobile.includes('*') ? 18888888888: mobile,
        model: "zsrw",
        platform: flag,
        questionId: this.obj.resourceId,
        roles: rolesStr,
        teamId: this.realTaskData.teamId,
        time: time,
        userId: this.userId,
      };
      // sing 遍历
      var sign = "";
      // 让arr = 把dataObj 拿出来当数组
      let arr = Object.entries(dataObj);
      // 遍历数组拼接字符串
      arr.forEach((item, index) => {
        sign += `${item[0]}=${item[1]}&`;
      });
      //使用setSha1加密
      let sha1sign = that.setSha1(sign.substring(0, sign.length - 1));
      dataObj.sign = sha1sign;
      axios({
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        method: "post",
        // url: process.env.sx_API,
        url: process.env.sx_2021_API,
        data: qs.stringify(dataObj),
      }).then((rs) => {
        if (rs.data.result){

          $("#app .container").addClass("contain_height");
          $(".container-header").hide();
          $(".study_header").hide();
          //开始跳转三天下
          that.iframeUrl = "";
          that.dialogVisible = true;
          that.isMini = true;
          that.isShowCPS = true;
          that.isShowCenter = false;
          that.dialogSwiper = false;
          that.diaLayout = "浮窗";

          this.iframeUrl = rs.data.value;
        }else{
          this.$messageWarning( '错误code码:  '+rs.data.error.code + '；' +rs.data.error.message)
        }

      });
      let url2 = `/${data.teamTaskId}/${data.sort}`;
      if (data.sort == 0) {
        return;
      }
      api.realTaskPreviousCompany(url2).then((rs) => {
        this.backObj = rs.data;
      });
    },
    taskSubmit() {
      //任务提交
      this.innerVisible = true;
      this.drawer2 = false;
      let time = new Date().getTime() + "";
      const TIME_COUNT = 3;
      let data = {
        id: this.obj.id,
        stationId: this.obj.stationId,
        teamTaskId: this.obj.teamTaskId,
      };
      api.submitTask(data).then((rs) => {
        if (rs.code != 0) {
          this.$message.error(rs.msg);
        }
      });
      if (!this.timer) {
        this.countDown = TIME_COUNT;
        this.timer = setInterval(() => {
          if (this.countDown > 1 && this.countDown <= TIME_COUNT) {
            this.countDown--;
            // this.drawer2 = true;
            this.getList();
          } else {
            clearInterval(this.timer);
            this.timer = null;
            this.innerVisible = false;
            this.back();
            this.getList();
          }
        }, 1000);
      }
    },
    fallback(i) {
      this.innerVisible = true;
      this.drawer2 = false;
      let time = new Date().getTime() + "";
      const TIME_COUNT = 3;
      if (i == 1) {
        let data = {
          id: this.obj.id,
          rollbackStationId: this.backObj.stationId,
          rollbackUserId: this.backObj.userId,
          teamTaskId: this.obj.teamTaskId,
          userId: this.userId,
          remark: this.notedata,
          sort: this.obj.sort,
        };
        // return;
        api.realTaskfallback(data).then((rs) => {
          if (rs.code == 0) {
            this.notedata = "";
            if (!this.timer) {
              this.countDown = TIME_COUNT;
              this.timer = setInterval(() => {
                if (this.countDown > 1 && this.countDown <= TIME_COUNT) {
                  this.countDown--;

                  this.getList();
                } else {
                  clearInterval(this.timer);
                  this.timer = null;
                  this.innerVisible = false;
                  this.back();
                  this.getList();
                  this.innerVisible2 = false;
                }
              }, 1000);
            }
          } else {
            this.$message.error(rs.msg);
          }
        });
      } else {
        this.innerVisible = false;
        this.innerVisible2 = false;
      }

      // this.timer = null;

      // this.drawer2 = true
    },
    taskfallback() {
      this.innerVisible2 = true;
      this.drawer2 = false;

      const TIME_COUNT = 3;
    },

    layoutChange(val) {
      //弹窗上下切换
      $("#fram").css("width", "100%");
      $("#fram").css("height", "100%");
      $(".el-dialog").css({ width: "100%", height: "100%", margin: "0" });
      $(".el-dialog__wrapper").css({
        width: "100%",
        height: "100%",
        top: "0",
        left: "0",
      });
      $(".el-dialog").css({ top: "0", left: "0", right: "0", bottom: "0" });
      $(".small_icon").hide();
      $(".large_icon").hide();
      if (val === "上下") {
        $("#fram").css("height", "70%");
        $(".el-dialog__wrapper").css({ height: "30%", top: "70%" });
        $(".el-dialog__header").css("cursor", "not-allowed");
      } else if (val === "左右") {
        $("#fram").css("width", "65%");
        $(".el-dialog__wrapper").css({ width: "35%", left: "65%" });
        $(".el-dialog__header").css("cursor", "not-allowed");
        $(".customHeight").css("border-left", "1px solid #d0d0d0");
      } else if (val === "浮窗") {
        $(".el-dialog").css({
          width: "50%",
          height: "30%",
          left: "50%",
          "margin-top": "70vh",
        });
        $(".el-dialog__header").css("cursor", "move");
        $(".small_icon").show();
        $(".large_icon").show();
      }
    },
    fontChange(val) {
      //字号切换
      if (val === "默认") {
        this.changeFont = false;
        this.$messageSuccess("已切换默认字号");
      } else if (val === "小号") {
        this.changeFont = true;
        this.$messageSuccess("已切换小号字号");
      }
    },
    back() {
      //浮窗的返回
      $(".my_iframe").css({ width: "100%", height: "100%" });
      $(".el-dialog").css({ width: "50%" });
      this.isShowCPS = false;
      this.isShowCenter = true;
      this.dialogVisible = false;
      this.activeName = "first"; //tag标签返回第一个
      $(".study_header").show();
      this.isHalf = false;
      this.isMini = true;
    },
    small() {
      this.isHalf = true;
      this.isMini = false;
      this.isSmall = true;
      $(".el-dialog").removeAttr("style", "");
      $(".el-dialog").removeClass("customHeight");
      $(".el-dialog").css({
        width: "50%",
        height: "40px",
        left: "50%",
        bottom: "0",
      });
    },
    large() {
      $(".el-dialog").css({
        width: "100%",
        height: "100%",
        left: "0",
        top: "0",
        "margin-top": "0",
      });
      this.isHalf = true;
    },
    largeHalf() {
      this.isHalf = false;
      this.isMini = true;
      this.isSmall = false;
      $(".el-dialog").removeAttr("style", "");
      $(".el-dialog").css({ width: "50%", height: "30%", left: "50%" });
    },
		imgCilck($event){
			if($event.target.nodeName=='IMG'){
				this.imgUrl = $event.target.currentSrc;
				this.showBigImg = true;
			}
		},
		clickMask(){
			this.imgUrl = '';
			this.showBigImg = false;
		}
  },
};
</script>

<style lang="scss">
#box {
  width: 100%;
  height: 100%;
  position: relative;
	.bigImg {
		position: fixed;
		width: 100%;
		height: 100%;
		z-index: 3000;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		overflow: hidden;
		.mask {
			background-color: #000000;
			opacity: .7;
			z-index: 3001;
			width: 100%;
			height: 100%;
			position: absolute;
		}
		.imgBox {
			position: absolute;
			z-index: 3002;
			display: flex;
			align-items: center;
			justify-content: center;
			width: 100%;
			height: 100%;
			img {
				display: inline-block;
				width: 70%;
				cursor: zoom-out;
			}
		}
	}
  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 64px;
    border-bottom: 2px solid #dde0e2;
    padding: 0 20px;
    span {
      font-size: 16px;
      color: #0d141e;
    }
    img {
      display: block;
      width: 26px;
      height: 26px;
      cursor: pointer;
    }
  }
  /*#fram {*/
  /*  position: absolute;*/
  /*  top: 0;*/
  /*  left: 0;*/
  /*}*/
  /*.customHeight {*/
  /*  height: 30%;*/
  /*  right: 0;*/
  /*}*/
  .el-dialog__wrapper {
    height: 100%;
    pointer-events: none;
    overflow: hidden;
    .el-dialog{
      margin: 0px;
      position: absolute;
      bottom: 0;
      height: 30%;
      right:0;
      background:rgba(237,244,255,1);
      pointer-events: auto!important;
      /*overflow: hidden!important;*/
      .el-dialog__header {
        /*background-color: rgba(64,158,255,.1);*/
        border-radius: 8px 8px 0 0;
        height: 30px;
        margin-top: 10px;
        padding: 0 20px !important;
      }
      .el-dialog__title {
        display: block;
        font-size: 14px;
        height: 45px;
        color: rgba(51, 51, 51, 1);
        padding-left: 5px;
        line-height: 45px;
      }
      .el-dialog__body {
        overflow-y: auto;
        background: white;
        padding: 0;
        height: calc(100% - 45px);
        .font_size {
          font-size: 12px !important;
        }
        .aside {
          user-select: text;
          width: 98%;
          height: 100%;
          // overflow: hidden;
          overflow-x: scroll;
          overflow-y: hidden;
          display: flex;
          margin: auto;
					.qesCont {
						img {
							display: inline-block;
							max-width: 100%;
							cursor: zoom-in;
						}
						img.big {
							cursor: zoom-out;
							max-width: 150%;
							width: 140%;
						}
					}
          .dialog_left {
            height: 100%;
            flex: 1;
            display: block;
            cursor: default !important;
            padding: 0 40px 0 10px;
            box-sizing: border-box;
            /*overflow: hidden;*/
            overflow: hidden;
            position: relative;
            .img_wrap {
              width: 100%;
              height: 100%;
              overflow: hidden;
              overflow-y: auto;
              display: block;
            }
            .pdf_wrap {
              width: 100%;
              height: 100%;
              overflow: hidden;
              overflow-y: auto;
              display: block;

              .btn-pre {
                position: absolute;
                left: 10px;
                top: 50%;
                padding: 5px 5px;
                margin: auto;
                font-size: 16px;
                width: 20px;
                height: 20px;
                background: rgba(0, 0, 0, 0.2);
                text-align: center;
                line-height: 20px;
                border-radius: 50%;
                cursor: pointer;
                &:hover {
                  background: #5397f7;
                  color: white;
                }
              }

              .btn-next {
                position: absolute;
                right: 50px;
                top: 50%;
                padding: 5px 5px;
                margin: auto;
                font-size: 16px;
                width: 20px;
                height: 20px;
                background: rgba(0, 0, 0, 0.2);
                text-align: center;
                line-height: 20px;
                border-radius: 50%;
                cursor: pointer;
                &:hover {
                  background: #5397f7;
                  color: white;
                }
              }

              .pdfCurrentPage {
                position: absolute;
                right: 50%;
                bottom: 15px;
              }
            }
            .zip_wrap {
              width: 100%;
              height: 90%;
              overflow: hidden;
              overflow-y: auto;
              overflow-x: auto;
              display: block;
            }
            .ql-editor {
              width: 100%;
              height: 100%;
              img {
                max-width: 100%;
              }
            }

            .menu-toggle {
              position: absolute;
              top: 50%;
              right: 10px;
              width: 10px;
              height: 64px;
              margin-top: -32px;
              border-radius: 5px;
              cursor: pointer;
              background: url("../../img/open.png");
              background-size: 100% 100%;
            }
            .menu-open {
              background: url("../../img/close.png");
              background-size: 100% 100%;
            }
          }
          .dialog_right {
            width: 28%;
            height: auto;
            display: block;
            padding-right: 10px;
          }
        }
      }
      .dia_span {
        position: absolute;
        min-width: 425px;
        max-width: 515px;
        height: 35px;
        top: 5px;
        right: 0;
        padding-top: 4px;
        .el-radio-group {
          height: 24px;
          .el-radio-button__inner {
            padding: 4px 10px;
            font-size: 12px;
          }
        }
        i {
          font-size: 18px;
          margin-left: 20px;
          cursor: pointer;
          float: left;
        }
      }
      .task_submit {
        position: absolute;
        right: 25px;
        top: 45px;
        padding: 0;
        width: 80px;
        height: 30px;
        border: 1px solid #5397f7;
        color: #5397f7;
        z-index: 3500;
      }
      .task_submit2 {
        position: absolute;
        right: 125px;
        top: 45px;
        padding: 0;
        width: 80px;
        height: 30px;
        border: 1px solid #5397f7;
        color: #5397f7;
        z-index: 3500;
      }
    }
  }
  .studenttask_warp {
    position: relative;
    height: 100%;
    padding: 0 24px;
    background: white;
    overflow-y: auto;
    .el-radio-button:focus:not(.is-focus):not(:active):not(.is-disabled) {
      box-shadow: none;
    }
    .btn_white {
      background: white;
      cursor: pointer;
    }
    .student_task_t {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      min-height: 55px;
      // height: 55px;
      line-height: 55px;
      border-bottom: 1px solid rgba(83, 151, 247, 1);
      .btn_null {
        border: none;
        background: none;
      }
      .task_t_r_search {
        padding-left: 16px;
        width: 180px;
        height: 28px;
        border: 1px solid rgba(226, 226, 226, 1);
        opacity: 1;
        border-radius: 4px;
        margin-right: 26px;
      }
      .task_t_r_btn {
        width: 72px;
        height: 30px;
        padding-top: 7px;
        // background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(83, 151, 247, 1);
        color: rgba(83, 151, 247, 1);
        opacity: 1;
        border-radius: 4px;
      }
    }
    .task_t_l {
      display: flex;
      justify-content: space-between;
      & > .btn_null {
        min-width: 70px;
      }
      i {
        display: inline-block;
        margin: 0 auto;
      }
      .post_date_box {
        display: flex;
        align-items: center;
        margin-left: 40px;
        width: 240px;
        padding-right: 20px;

        label {
          width: 80px;
        }

        .el-input__inner {
          width: 160px;
          height: 32px;
          color: rgba(153, 153, 153, 1);
        }
      }
      .post_ul {
        max-width: 881px;
        display: flex;
        flex-wrap: wrap;
        justify-content: left;
        align-items: center;
        // min-height: 32px;

        li {
          padding: 0 14px;
          margin: 10px 0px 10px 16px;
          height: 32px;
          line-height: 32px;
          color: white;
          background-color: rgba(83, 151, 247, 1);
        }
      }
    }
    .task_t_r {
      display: flex;
      justify-content: space-between;
    }
    .el-radio-button__inner {
      margin: 0 20px;
      border-radius: 0;
    }
    .el-checkbox-button__inner {
      margin: 0 20px;
      border-radius: 0;
      border: 0px;
      padding: 12px 21px;
    }
    .student_task_b {
      .student_task_date {
        & > i {
          font-size: 12px;
        }
      }
      .student_task_date .el-radio-button__inner {
        color: rgba(153, 153, 153, 1);
        font-size: 12px;
      }
      .student_task_b_btn_null {
        margin-left: 20px;
        width: 56px;
        height: 24px;
        border: 1px solid #e4e8f1;
        opacity: 1;
        border-radius: 12px;
        color: #5397f7;
        font-size: 10px;
        background: white;
        cursor: pointer;
      }
      & > div {
        display: flex;
        justify-content: space-between;
        justify-content: left;
        line-height: 50px;
        height: 50px;
        color: rgba(153, 153, 153, 1);
        i {
          color: black;
        }
        span {
          margin: 0 20px;
        }
        color: rgba(153, 153, 153, 1);
      }
      .student_task_company {
        height: auto;
        & > i {
          font-size: 12px;
        }
      }
      .el-radio-button__inner {
        border: 1px solid white;
        box-shadow: 0 0 0 0 white !important;
        // color: rgba(153, 153, 153, 1);
        color: rgba(153, 153, 153, 1);
        font-size: 12px;
      }
      .el-radio-button {
        color: rgba(153, 153, 153, 1);
      }
      .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        background: white;
        color: rgba(83, 151, 247, 1);
        font-weight: bolder;
      }
      .el-checkbox-button.is-checked .el-checkbox-button__inner {
        background: white;
        color: rgba(83, 151, 247, 1);
        font-weight: bolder;
        border: none;
        box-shadow: 0 0 0 0 white !important;
      }
    }
    .student_task_company {
      display: flex;
      ::-webkit-scrollbar {
        /*显示滚轮 因为最下面有个全局隐藏滚轮 而这里需要滚轮*/
        display: block;
        width: 5px;
        height: 8px;
        background-color: #aaa; /* or add it to the track */
      }
      //  height: 80px !important;
      .el-checkbox-group > label {
        height: 38px;
      }
      .el-checkbox-group .el-checkbox-button__inner {
        color: rgba(153, 153, 153, 1);
        font-size: 12px;
        height: 38px;
        display: flex;
        align-items: center;
      }
      .largeArray {
        padding-top: 8px;
        width: 85%;
        flex-wrap: wrap;
        max-height: 180px;
        overflow-y: auto;
        line-height: 28px;
      }
      position: relative;
      .student_task_company_r {
        position: absolute;
        right: 0;
        button {
          width: 56px;
          height: 24px;
          border: 1px solid rgba(228, 232, 241, 1);
          opacity: 1;
          border-radius: 12px;
          color: rgba(83, 151, 247, 1);
          font-size: 10px;
        }
      }
    }
    .student_task_type {
      & > i {
        font-size: 12px;
      }
    }
    .student_task_state {
      & > i {
        font-size: 12px;
      }
      .el-radio-group {
        padding-top: 5px;
      }
    }
    .task_ul_header {
      li {
        font-size: 12px;
        color: rgba(153, 153, 153, 1);
      }
    }
    .task_ul {
      height: calc(40px * 10 + 10px);
      overflow-y: auto;
      li {
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        min-height: 40px;

        line-height: 40px;
        border: 1px solid rgba(226, 226, 226, 1);
        border-top: 0;
        & > div {
          flex: 1;
          text-align: center;
        }
        button {
          width: 56px;
          height: 24px;
          border: 1px solid rgba(228, 232, 241, 1);
          opacity: 1;
          border-radius: 12px;
          color: rgba(83, 151, 247, 1);
          font-size: 10px;
        }

        .li_div_taskName {
          flex: 2.5;
          text-align: left;
          color: rgba(83, 151, 247, 1);
        }
        .li_div_taskCompany {
          flex: 2.5;
          text-align: left;
        }
        .li_div_message {
          color: rgba(83, 151, 247, 1);
          cursor: pointer;
        }
        .li_div_operation {
          flex: 2;
          color: rgba(83, 151, 247, 1);
        }
      }
			.li_div_No {
				position: relative;
				i {
					position: absolute;
					left: 12px;
				}
			}
      .li_header {
        background-color: rgba(83, 151, 247, 0.1);
        border: 0;
        div {
          color: black;
        }
      }
    }
		.task_title {
			margin-bottom: 20px;
			text-align: right;
			color: red;
		}
    .task_ul_header {
      @extend .task_ul;
      height: 40px;
      & > li > div {
        color: rgba(153, 153, 153, 1) !important;
        font-size: 12px;
      }
    }
    .heng {
      display: block;
      display: inline-block;
      width: 16px;
      height: 1px;
      background: rgba(153, 153, 153, 1);
      opacity: 1;
      margin: 0 6px !important;
      border-radius: 8px;
    }
    .picker {
      display: inline-block;
      .el-date-editor {
        width: 115px;
      }
      .el-input__inner {
        width: 115px;
        height: 30px;
        padding: 7px 0px 7px 12px;
        background: url("../../../../../../static/images/date.png") no-repeat;
        background-position: 91px 5px;
      }
    }
    .el-input__prefix {
      display: none;
    }
    .r_box {
      height: 100%;
    }
    .drawer1 {
      .el-drawer {
        width: 480px !important;
        .drawer1_r_box {
          position: relative;
          height: 100%;
          // .drawer1_r_header {
          //   padding: 0 21px;
          //   height: 56px;
          //   font-weight: bold;
          //   font-size: 16px;
          //   line-height: 56px;
          //   border-bottom: 1px solid rgba(221, 224, 226, 1);
          // }
          .drawer1_r_title {
            line-height: 33px;

            width: 94%;
            padding: 20px 20px 0 22px;
            p {
              font-size: 12px;
              color: rgba(153, 153, 153, 1);
            }
          }
          .drawer1_r_ct {
            width: 100%;
            padding: 37px 22px 0 22px;
            p {
              padding: 13px 0;
              font-size: 12px;
              color: rgba(153, 153, 153, 1);
            }
            textarea {
              padding-top: 12px;
              width: 436px;
              height: 142px;
              border: 1px solid rgba(226, 226, 226, 1);
              opacity: 1;
              border-radius: 4px;
              resize: none;
              text-indent: 25px;
            }
          }
          .drawer1_r_footer {
            position: absolute;
            bottom: 50px;
            width: 100%;
            display: flex;
            justify-content: center;

            .cancel {
              margin-right: 24px;
              background: rgba(185, 214, 255, 1);
            }
          }
        }
      }
    }
    .drawer2 {
      .el-drawer {
        width: 1200px !important;
        .r_header {
          display: flex;
          padding-left: 21px;

          height: 56px;
          align-items: center;
          font-weight: bolder;
          font-size: 16px;
          color: rgba(13, 20, 30, 1);
          border-bottom: 1px solid rgba(13, 20, 30, 1);
        }
      }
      .r_box {
        .steps_box {
          height: 100px;
          margin-top: calc(3% + 20px);

          .el-step__icon-inner {
            display: none;
          }
          .is-success {
            color: rgba(3, 213, 124, 1);
            .is-text {
              border: 6px solid rgba(3, 213, 124, 1);
            }
          }
          .is-process {
            color: rgba(83, 151, 247, 1);
            // background: rgba(83, 151, 247, 1);
            .is-text {
              border: 6px solid rgba(83, 151, 247, 1);
            }
          }

          .is-wait {
            color: rgba(204, 204, 204, 1);
            .is-text {
              border: 6px solid rgba(204, 204, 204, 1);
            }
          }
        }
        .r_ul_box {
          font-size: 12px;
          padding: 0 22px;
          margin-top: calc(3% + 20px);
        }
        .task_r_ul {
          li {
            display: flex;
            justify-content: space-between;

            height: 40px;
            line-height: 40px;
            border: 1px solid rgba(226, 226, 226, 1);
            border-top: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            & > div {
              flex: 1;
              text-align: center;
            }

            .r_li_div_No {
              flex: 0.4;
              text-align: center;
              color: #666666;
            }
            .r_li_div_record {
              flex: 2;
              text-align: left;
              color: #666666;
            }
            .r_li_div_time {
              flex: 1;
              text-align: left;
              color: #666666;
            }
            .r_li_div_message {
              flex: 1;
              text-align: left;
              color: #666666;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            //  <div class="r_li_div_No">序号</div>
            //       <div class="r_li_div_record">操作记录</div>
            //       <div class="r_li_div_time">任务发布时间</div>

            //       <div class="r_li_div_message">留言</div>
          }
          .r_li_header {
            background-color: rgba(83, 151, 247, 0.1);
            border: 0;
            div {
              color: #999999;
            }
          }
        }
      }
      .el-drawer__body {
        height: 100%;
      }
      .r_box2 {
        height: 100%;
        display: flex;
        flex-direction: column;

        .r_ct {
          padding: 20px;
          flex: 7;
          overflow: auto;
          width: calc(100% - 10px);
          img {
						display: inline-block;
						max-width: 100%;
						cursor: zoom-in !important;
          }
        }
        .r_footer {
          height: 56px;
          display: flex;
          justify-content: center;
          align-items: center;
          button {
            padding-left: 20px;
            width: 94px;
            height: 32px;
            margin-right: 32px;
            cursor: pointer;
            background: white
              url("../../../../../../static/images/study/icon/kaishi.png")
              no-repeat 10px 8px;

            border: 1px solid rgba(83, 151, 247, 1);
            color: rgba(83, 151, 247, 1);
            opacity: 1;
            border-radius: 4px;
          }
        }
      }
    }
  }
}
.layui-layer {
  overflow: hidden;
  border-radius: 5px;
}
.layui-layer-content {
  width: 100%;
  height: 98% !important;
  padding-bottom: 20px;
}
.layui-layer-title {
  height: 30px;
  line-height: 30px;
}
.layui-layer-setwin {
  top: 10px;
}
.contain_height {
  height: 100%;
}
.count_down_dialog {
  /*position: fixed;*/
  /*width: 100%;*/
  /*height: 100%;*/
  .el-dialog{
    /*position: fixed !important;*/
    width: 290px !important;
    /*height: 200px !important;*/
    /*left: 0 !important;*/
    /*right: 0 !important;*/
    /*margin: 15vh auto !important;*/
  }
  .el-dialog__header {
    width: 100%;
    height: 48px;
    background: rgba(237, 244, 255, 1);
    padding: 20px 15px 0 15px;
    box-sizing: border-box;
    border-radius: 8px 8px 0 0;
    span {
      display: block;
      font-size: 14px;
      font-weight: 400;
      color: rgba(83, 151, 247, 1);
      border-left: 2px solid #5397f7;
      line-height: 10px;
      padding-left: 5px;
    }
    .el-dialog__headerbtn {
      top: 18px;
    }
  }
  .count_down_main {
    p {
      text-align: center;
      margin-top: 16px;
      &:first-child {
        font-size: 16px;
      }
      &:last-child {
        font-size: 14px;
        margin-bottom: 16px;
        span {
          color: #db3737;
        }
      }
    }
  }
}
.count_down_dialog2 {
  /*position: fixed;*/
  /*width: 100%;*/
  /*height: 100%;*/
  .el-dialog{
    /*position: fixed !important;*/
    /*width: 290px !important;*/
    pointer-events: auto!important;
    /*height: 200px !important;*/
    /*left: 0 !important;*/
    /*right: 0 !important;*/
    /*margin: 15vh auto !important;*/
  }
  .count_down_dialog_header {
    padding: 0 21px;
    height: 56px;
    font-weight: bold;
    font-size: 16px;
    line-height: 56px;
    border-bottom: 1px solid rgba(221, 224, 226, 1);
  }
  .count_down_dialog_r_title {
    line-height: 33px;
    width: 100%;
    padding: 10px 22px 0 22px;
		box-sizing: border-box;
    p {
      font-size: 12px;
      color: rgba(153, 153, 153, 1);
    }
  }
  .count_down_dialog_r_ct {
    width: 100%;
    padding: 20px 22px 0 22px;
		box-sizing: border-box;
    p {
      padding: 13px 0;
      font-size: 12px;
      color: rgba(153, 153, 153, 1);
    }
    textarea {
      padding-top: 12px;
      width: 100%;
      height: 142px;
      border: 1px solid rgba(226, 226, 226, 1);
      opacity: 1;
      border-radius: 4px;
      resize: none;
      text-indent: 25px;
    }
  }
  .count_down_dialog_r_footer {
    position: absolute;
    bottom: 15px;
    width: 100%;
    display: flex;
    justify-content: center;

    .cancel {
      margin-right: 24px;
      background: rgba(185, 214, 255, 1);
    }
  }
}
.checkButton {
  line-height: 30px;
  button {
    margin: 0 20px;
    padding: 12px 20px;
    font-size: 12px;
    color: #999999;
    border: white;
    background: white;
    border: none;
    outline: none;
  }
}
.null_box {
  padding-top: 100px;
  height: 100px;
  text-align: center;
  p {
    color: #999999;
  }
  img {
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/realTask/studentTask.vue